import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import differenceInMinutes from "date-fns/differenceInMinutes";
import { parseISO } from 'date-fns';
import api from "api";
import { connect } from "react-redux";
import stateMap from "store/stateMap";


const LastSeen = connect(stateMap)((props) => {
    const [lastSeen, setLastSeen] = useState(false);

    useEffect(() => {

        if(props.auth.user.UserID !== props.user_id)
        {
            api('/Profile/LastSeen', 'get', {
                user_id : props.user_id
            }, 'Bearer ' + props.auth.token)
                .then(response => {
                    let LastSeenDate    = parseISO(response.last_seen);
                    let TimeDifference  = differenceInMinutes(new Date(), LastSeenDate)
                    if(TimeDifference > 1)
                    {
                        setLastSeen(`Last seen ${formatDistanceToNow(LastSeenDate)} ago`);
                    }
                    else
                    {
                        setLastSeen('Online');
                    }
                    
                });
        }
    }, [])

    return (
        <span className="component-last-seen">{lastSeen}</span>
    )
})

export default LastSeen;